export const BLOCK_TYPE_COMPANIES_LIST_LINKS = 'companies-list-links';
